"use client";

import { X } from "lucide-react";
import { useState } from "react";
import { Badge } from "@/components/ui/design-system/badge";

interface DismissiblePersonalStagingBadgeProps {
  stagingLabel: string;
}

export function DismissiblePersonalStagingBadge({
  stagingLabel,
}: DismissiblePersonalStagingBadgeProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-0 top-nf-ds-2 z-40 flex justify-center px-nf-ds-3">
      <Badge
        className="h-7 gap-1.5 border-border/80 bg-card/90 px-2 font-normal text-[11px] text-nf-ds-gray-600 shadow-nf-ds-xs backdrop-blur-md"
        variant="outline"
      >
        <span
          aria-hidden="true"
          className="size-1.5 rounded-full bg-nf-ds-purple-product/60"
        />
        <span>Previewing</span>
        <span aria-hidden="true" className="text-nf-ds-gray-300">
          ·
        </span>
        <span className="text-nf-ds-text-body">{stagingLabel}</span>
        <button
          aria-label="Dismiss preview environment indicator"
          className="pointer-events-auto ml-0.5 inline-flex size-5 cursor-pointer items-center justify-center rounded-full text-nf-ds-gray-400 transition-colors hover:bg-nf-ds-bg-surface-2 hover:text-nf-ds-text-body focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-nf-ds-purple-product/30"
          onClick={() => setIsVisible(false)}
          type="button"
        >
          <X aria-hidden="true" className="size-3" strokeWidth={1.75} />
        </button>
      </Badge>
    </div>
  );
}
